module.exports = __webpack_public_path__ + "img/16_108.7e48ffc5.png";